module.exports = __webpack_public_path__ + "static/media/pdm_icon.81c677c6.png";